import HistoryCard from "./HistoryCard";

export default HistoryCard;
